<template>
<div class="demands">
  <breadcrumb :items="[{ text: 'Demandas', active: true }]" />
  <b-alert variant="danger" show v-if="error">{{error}}</b-alert>
  <loading :loading="!demands && !error" msg="Carregando lista de demandas" />
  <no-item :list="demands" />
  <table class="table b-table b-table-stacked-lg">
    <thead>
      <tr>
        <th>Cód. / Data</th>
        <th>Cliente</th>
        <th>Categoria</th>
        <th>Demanda</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(demand, index) in demands" :key="index">
        <td>
          <router-link :to="'/demanda/'+demand._id">
            Demanda #{{demand.code}}
          </router-link>
          <br>
          <small>{{demand.createdAt | data}}</small>
        </td>
        <td>
          {{demand.name}}
          <br>
          <span class="badge badge-primary">{{demand.email}}</span>
          <br>
          <span class="badge badge-primary">{{demand.phone}}</span>
        </td>
        <td>
          {{demand.category}}
        </td>
        <td>
          <small>{{demand.description}}</small>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import axios from 'axios'
import Loading from '@/components/Loading'
import NoItem from '@/components/NoItem'

export default {

  name: 'Demands',
  data() {
    return {
      demands: null
    }
  },
  created() {
    axios.get('demands').then(response => {
      this.demands = response.data
    }).catch(this.showError)
  },
  methods: {
    demandTotal(demand) {
      return demand.items.reduce((a, b) => {
        return a + b.total
      }, 0)
    },
    changeStatus(index) {
      axios.put('demands/'+this.demands[index]._id, {status: this.demands[index].status}).then(response => {
        if (response.data) {
          this.notify("Status atualizado com sucesso!")
        }
      }).catch(this.showError)
    }
  },

  components: {
    Loading,
    NoItem,
  }
};
</script>
